export enum InviteStatusEnum {
  Pending = 'PENDING',
  Accepted = 'ACCEPTED',
  Archived = 'ARCHIVED',
}
